import Model, { attr } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';

export default class FinalSummary extends Model {
  declare [Type]: 'final-summary';

  @attr('string') declare kind: string;
  @attr('string') declare message: string | null;
  @attr('string') declare messageHtml: string;
  @attr('string') declare imageUrl: string | null;
  @attr('string') declare videoUrl: string | null;
}
